import React from 'react';
import { ArrowRight, Sparkles } from 'lucide-react';

interface SuggestedActionsProps {
  actions: string[];
  onActionClick: (action: string) => void;
}

const SuggestedActions: React.FC<SuggestedActionsProps> = ({ actions, onActionClick }) => {
  if (!actions || actions.length === 0) return null;

  return (
    <div className="space-y-2">
      <div className="flex items-center gap-2 text-xs font-semibold text-slate-400">
        <Sparkles className="w-3 h-3" />
        <span>Suggested next steps:</span>
      </div>

      <div className="flex flex-wrap gap-2">
        {actions.map((action, index) => (
          <button
            key={index}
            onClick={() => onActionClick(action)}
            className="group flex items-center gap-2 px-3 py-2 bg-gradient-to-r from-purple-950/30 to-blue-950/30 hover:from-purple-900/40 hover:to-blue-900/40 border border-purple-700 rounded-lg text-sm text-slate-300 hover:text-slate-100 transition-all"
          >
            <span>{action}</span>
            <ArrowRight className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity" />
          </button>
        ))}
      </div>
    </div>
  );
};

export default SuggestedActions;
